import React from "react";
import { Link } from "react-router-dom";
import CalculateIcon from "@mui/icons-material/Calculate";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { EyebrowText } from "../../atoms/EyebrowText";
import { FeatureCard } from "../../atoms/FeatureCard";
import "./styles.css";

/**
 * Sección "Simulador de crédito" para la home.
 * Layout de dos columnas (en desktop) separadas por un divider vertical, con
 * franjas decorativas naranja + azul navy arriba y abajo.
 */
export const LoanSimulatorSection = () => {
  // Las imágenes viven en /public/images/icons; las usamos como assets decorativos
  const benefits = [
    {
      image: "/images/icons/cronografo.png",
      label: "Crédito aprobado rápido",
    },
    {
      image: "/images/icons/dinero.png",
      label: "Cuotas bajas",
    },
    {
      image: "/images/icons/motocicleta.png",
      label: "Amplio catálogo",
    },
  ];

  return (
    <section className="loan-simulator" aria-labelledby="loan-simulator-title">
      {/* Franja decorativa superior */}
      <div className="loan-simulator__stripes loan-simulator__stripes--top" aria-hidden="true">
        <span className="loan-simulator__stripe loan-simulator__stripe--orange" />
        <span className="loan-simulator__stripe loan-simulator__stripe--navy" />
      </div>

      <div className="loan-simulator__content">
        {/* Columna izquierda: heading + tarjetas de beneficios */}
        <div className="loan-simulator__left">
          <EyebrowText>¿Listo para tu moto?</EyebrowText>
          <h2 id="loan-simulator-title" className="loan-simulator__heading">
            ¡Tu moto ideal está a un click!
          </h2>

          <div className="loan-simulator__benefits">
            {benefits.map((benefit) => (
              <FeatureCard
                key={benefit.label}
                icon={
                  <img
                    src={benefit.image}
                    alt=""
                    aria-hidden="true"
                  />
                }
                label={benefit.label}
              />
            ))}
          </div>
        </div>

        {/* Divider vertical (sólo desktop) */}
        <div className="loan-simulator__divider" aria-hidden="true" />

        {/* Columna derecha: copy + CTA */}
        <div className="loan-simulator__right">
          <h3 className="loan-simulator__sub-heading">
            Descubre cuánto puedes pagar al mes por tu moto soñada.
          </h3>
          <p className="loan-simulator__description">
            Sin compromisos, sin trámites — solo ingresa el valor de la moto y
            te calculamos la cuota estimada.
          </p>

          <Link
            to="/financiamiento"
            className="loan-simulator__cta"
            aria-label="Simula tu crédito aquí"
          >
            <CalculateIcon className="loan-simulator__cta-icon" aria-hidden="true" />
            <span>Simula tu crédito aquí</span>
          </Link>

          <div className="loan-simulator__safety">
            <VerifiedUserIcon
              className="loan-simulator__safety-icon"
              aria-hidden="true"
            />
            <span>Proceso seguro — sin costo ni compromiso</span>
          </div>
        </div>
      </div>

      {/* Franja decorativa inferior */}
      <div className="loan-simulator__stripes loan-simulator__stripes--bottom" aria-hidden="true">
        <span className="loan-simulator__stripe loan-simulator__stripe--orange" />
        <span className="loan-simulator__stripe loan-simulator__stripe--navy" />
      </div>
    </section>
  );
};
